import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "FirstAid.svg",
  "use": "FirstAid.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"FirstAid.svg\"><path d=\"M54,39H39V54a2,2,0,0,1-2,2H27a2,2,0,0,1-2-2V39H10a2,2,0,0,1-2-2V27a2,2,0,0,1,2-2H25V10a2,2,0,0,1,2-2H37a2,2,0,0,1,2,2V25H54a2,2,0,0,1,2,2V37A2,2,0,0,1,54,39Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol